let responseReducer = function(response = '', action) {
    switch(action.type) {
        case 'GET_HOTEL_AVAILABILITY_BEGIN':
            return action.response;
        case 'GET_HOTEL_AVAILABILITY_END':
            return action.response;
        case 'GET_ALLOCATION_ENQUIRIES_BEGIN':
            return action.response;
        case 'GET_ALLOCATION_ENQUIRIES_END':
            return action.response;
        case 'CLEAR_SEARCH_RESPONSE':
            return action.response;
        default:
            return response;
    }
}

export default responseReducer